import React from "react";
import PropTypes from "prop-types";

const StockData = ({ stockData }) => {
  return stockData ? (
    <div className="stock-rates stock-rates--header">
      <span>NYSE: LHX</span>
      <i className={`stock-rates__icon mx-4 ${stockData.change_direction}`} />
      <span className="stock-rates__last_trade">{stockData.last_trade}</span>
      <span className="stock-rates__change ml-4"> {stockData.change}</span>
    </div>
  ) : (
    ""
  );
};

StockData.propTypes = {
  stockData: PropTypes.object.isRequired,
};
export default StockData;
